export const FRIENDLY_STATUS = {
  pending: "Pending", in_progress: "In progress", on_hold: "On hold",
  awaiting_signoff: "Awaiting sign-off", awaiting_sign_off: "Awaiting sign-off",
  pending_delegated: "Pending delegated", completed_by_cleaners: "Completed by cleaners",
  completed: "Completed", skipped: "Skipped", active: "Active", inactive: "Inactive",
  raised: "Raised with contractor",
};

export function friendlyStatus(value, fallback = "Not started") {
  if (!value) return fallback;
  return FRIENDLY_STATUS[value] || String(value).replaceAll("_", " ").replace(/^./, c => c.toUpperCase());
}

export function assignmentLabel(assignment) {
  if (!assignment) return "Unassigned";
  return `${assignment.type === "role" ? "Role: " : ""}${assignment.target_label_snapshot || "Unavailable assignee"}`;
}
